import { render, staticRenderFns } from "./areaDetail.vue?vue&type=template&id=3de44d4d&scoped=true"
import script from "./areaDetail.vue?vue&type=script&lang=js"
export * from "./areaDetail.vue?vue&type=script&lang=js"
import style0 from "./areaDetail.vue?vue&type=style&index=0&id=3de44d4d&prod&lang=less"
import style1 from "./areaDetail.vue?vue&type=style&index=1&id=3de44d4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de44d4d",
  null
  
)

export default component.exports